import { RootState } from '@/store'

export const getCatalogAppInstance = (state: RootState) => {
  if (state.catalogApp) {
    return state.catalogApp.appInstance
  }

  return null
}

export const getCatalogApp = (state: RootState) => {
  return state.catalogApp.app
}
